
            const data = {"name":"downArrow","data":{"width":"20","height":"42","viewBox":"0 0 20 42","data":"<path pid=\"0\" d=\"M9.646 32.354a.5.5 0 0 0 .708 0l3.182-3.182a.5.5 0 1 0-.708-.707L10 31.293l-2.828-2.828a.5.5 0 1 0-.708.707l3.182 3.182ZM9.5 10v22h1V10h-1Z\" _fill=\"#333\"/>","originalColors":[{"type":"fill","color":"#333"}],"stopColors":[]}}
        
                module.exports = data
                